export default "__VITE_ASSET__DHpD2wT6__"